import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, BadgePercent, Copy } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function CouponsPage() {
    const [coupons, setCoupons] = useState([]);
    useEffect(() => { api.get("/coupons/available").then(({ data }) => setCoupons(data)).catch(() => setCoupons([])); }, []);
    const copy = (c) => { navigator.clipboard.writeText(c); toast.success("Code copied"); };
    return (
        <div className="pb-32">
            <header className="px-4 pt-5 pb-4 flex items-center gap-3 bg-card border-b border-border">
                <Link to="/profile" className="p-1 -ml-1"><ArrowLeft size={22} /></Link>
                <h1 className="text-base font-bold">Coupons</h1>
            </header>
            <div className="p-4 space-y-3 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-3 lg:items-start 2xl:grid-cols-3">
                {coupons.length === 0 ? <p className="text-center py-20 text-muted-foreground lg:col-span-full">No coupons</p> : coupons.map((c) => (
                    <div key={c.id} data-testid={`coupon-card-${c.code}`} className="bg-gradient-to-r from-accent/15 to-primary/10 border border-dashed border-primary/40 rounded-2xl p-4">
                        <div className="flex items-center gap-2 text-primary"><BadgePercent size={18} /><span className="text-[10px] uppercase tracking-[0.16em] font-bold">Code</span></div>
                        <div className="flex items-center justify-between mt-1">
                            <p className="font-display font-bold text-xl">{c.code}</p>
                            <button data-testid={`copy-${c.code}`} onClick={() => copy(c.code)} className="text-xs font-semibold text-primary inline-flex items-center gap-1"><Copy size={12} /> Copy</button>
                        </div>
                        <p className="font-semibold text-sm mt-1">{c.title}</p>
                        <p className="text-xs text-muted-foreground">{c.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
